import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { TopAnimesList } from './TopAnimesList.jsx'
import { fetchTopAnimes } from '../../../store/slices/animeFeatures.slice.js'

export function TopAnimesIndex() {
  const dispatch = useDispatch()
  const { topAnimes, loading, error } = useSelector((state) => state.animeFeatures)

  useEffect(() => {
    dispatch(fetchTopAnimes()) // ✔ שליחת הפעולה ל-Redux
  }, [dispatch])

  return (
    <section className="mt-6">
      {loading && !topAnimes.length && <p>טוען נתונים...</p>}

      {error && <p className="text-red-500">שגיאה: {error}</p>}
      <TopAnimesList animeList={topAnimes} />
    </section>
  )
}
